module.exports = __webpack_public_path__ + "img/cyclops1.c711abaf.png";